module.exports = __webpack_public_path__ + "static/media/1_simplex_A_aqua_square.8879d33d.png";